const Tabbar = () => import(/* webpackChunkName: "Tabbar" */ '@/components/tabBar')

export default [
  {
    path: '/user',
    name: 'userLayout',
    redirect: { name: 'user' },
    component: () => import('@/views/layout'),
    children: [
      {
        path: '/user',
        name: 'user',
        components: {
          default: () => import('@/views/user/user'),
          tabbar: Tabbar
        },
        meta: {
          keepAlive: false,
          includeKeepAlive: ['personal']
        }
      },
      {
        path: '/user/account',
        name: 'account',
        component: () => import('@/views/user/account'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/releaseNotes',
        name: 'releaseNotes',
        component: () => import('@/views/user/releaseNotes'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/articleList/:title',
        name: 'articleList',
        component: () => import('@/views/user/articleList'),
        meta: {
          keepAlive: true,
          includeKeepAlive: ['personal', 'detail']
        }
      },
      {
        path: '/user/account/editAccount/:title',
        name: 'editAccount',
        component: () => import('@/views/user/account/editAccount'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/account/editPhone',
        name: 'editPhone',
        component: () => import('@/views/user/account/editPhone'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/set',
        name: 'set',
        component: () => import('@/views/user/set'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/account/editEmail',
        name: 'editEmail',
        component: () => import('@/views/user/account/editEmail'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/accountFlow',
        name: 'accountFlow',
        component: () => import('@/views/user/accountFlow'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/behaviour/:title',
        name: 'behaviour',
        component: () => import('@/views/user/behaviour'),
        meta: {
          keepAlive: true,
          includeKeepAlive: ['personal', 'detail']
        }
      },
      {
        path: '/user/fans/:title',
        name: 'fans',
        component: () => import('@/views/user/fans'),
        meta: {
          keepAlive: true,
          includeKeepAlive: ['personal', 'detail']
        }
      },
      {
        path: '/user/paymentArticle/:title',
        name: 'paymentArticle',
        component: () => import('@/views/user/paymentArticle'),
        meta: {
          keepAlive: true,
          includeKeepAlive: ['personal', 'detail']
        }
      },
      {
        path: '/user/noticeList',
        name: 'noticeList',
        component: () => import('@/views/user/noticeList'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/card',
        name: 'mycard',
        component: () => import('@/views/user/mycard'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/user/signin',
        name: 'Signin',
        component: () => import('@/views/user/signin'),
        meta: {
          keepAlive: false
        }
      }
    ]
  }
]
